import { Component } from '@angular/core';

@Component({
  selector: 'app-privacypolicy',
  imports: [],
  templateUrl: './privacypolicy.component.html',
  styleUrl: './privacypolicy.component.scss'
})
export class PrivacypolicyComponent {

}
